import React, { useState } from 'react';
import { useSiteConfig } from '../hooks/useSiteConfig';
import Editable from '../components/Editable';
import './Pages.css';

const DEFAULT_CONTACT = {
  intro: "Have a question or project in mind? We'd love to hear from you.",
  email: 'loganccurtis@gmail.com',
  phone: '(307) 409-2600',
  form_endpoint: '',
};

export default function Contact() {
  const { config } = useSiteConfig();
  const contact = config.contact || DEFAULT_CONTACT;
  const socials = config.socials || {};

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);
  const [sending, setSending] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg('');
    const endpoint = contact.form_endpoint || DEFAULT_CONTACT.form_endpoint;
    if (endpoint) {
      setSending(true);
      try {
        const res = await fetch(endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(formData),
        });
        if (!res.ok) throw new Error(`Send failed: ${res.status}`);
        setSubmitted(true);
        setFormData({ name: '', email: '', subject: '', message: '' });
        setTimeout(() => setSubmitted(false), 5000);
      } catch (err) {
        setErrorMsg(err.message || 'Failed to send message. Please try again.');
      }
      setSending(false);
    } else {
      setSubmitted(true);
      setFormData({ name: '', email: '', subject: '', message: '' });
      setTimeout(() => setSubmitted(false), 5000);
    }
  };

  const email = contact.email || DEFAULT_CONTACT.email;
  const phone = contact.phone || DEFAULT_CONTACT.phone;
  const intro = contact.intro || DEFAULT_CONTACT.intro;

  const socialLinks = [
    { key: 'linkedin', label: 'LinkedIn', url: socials.linkedin },
    { key: 'twitter', label: 'Twitter', url: socials.twitter },
    { key: 'facebook', label: 'Facebook', url: socials.facebook },
    { key: 'instagram', label: 'Instagram', url: socials.instagram },
  ].filter((s) => s.url && String(s.url).trim());

  return (
    <main className="page-content">
      <section className="page-hero">
        <div className="container">
          <h1>Get in Touch</h1>
          <p>{intro}</p>
        </div>
      </section>

      <section className="container page-section">
        <div className="contact-layout">
          <div className="contact-form">
            <h2>Send us a Message</h2>
            {submitted && (
              <div className="success-message">
                Thank you for your message! We'll get back to you soon.
              </div>
            )}
            {errorMsg && (
              <div className="success-message" style={{ background: '#fee2e2', color: '#991b1b', borderLeftColor: '#dc2626' }}>
                {errorMsg}
              </div>
            )}
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Full Name</label>
                <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} required />
              </div>
              <div className="form-group">
                <label htmlFor="email">Email Address</label>
                <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} required />
              </div>
              <div className="form-group">
                <label htmlFor="subject">Subject</label>
                <input type="text" id="subject" name="subject" value={formData.subject} onChange={handleChange} required />
              </div>
              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea id="message" name="message" rows="5" value={formData.message} onChange={handleChange} required></textarea>
              </div>
              <button type="submit" className="btn btn-primary" disabled={sending}>
                {sending ? 'Sending…' : 'Send Message'}
              </button>
            </form>
          </div>

          <div className="contact-info">
            <Editable descriptor={{ kind: 'config', key: 'contact', label: 'Contact information' }}>
              <div>
                <h2>Contact Information</h2>
                {email && (
                  <div className="info-card">
                    <h3>Email</h3>
                    <p><a href={`mailto:${email}`}>{email}</a></p>
                  </div>
                )}
                {phone && (
                  <div className="info-card">
                    <h3>Phone</h3>
                    <p><a href={`tel:${String(phone).replace(/[^+\d]/g, '')}`}>{phone}</a></p>
                  </div>
                )}
              </div>
            </Editable>
            {socialLinks.length > 0 && (
              <Editable descriptor={{ kind: 'config', key: 'socials', label: 'Social links' }}>
                <div className="info-card">
                  <h3>Follow Us</h3>
                  <p>
                    {socialLinks.map((s, i) => (
                      <React.Fragment key={s.key}>
                        <a href={s.url} target="_blank" rel="noopener noreferrer">{s.label}</a>
                        {i < socialLinks.length - 1 ? ' | ' : ''}
                      </React.Fragment>
                    ))}
                  </p>
                </div>
              </Editable>
            )}
          </div>
        </div>
      </section>
    </main>
  );
}
